import React, { Fragment, useEffect } from "react";
import TabsetProfile from "./tabset-profile";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, Col, Container, Row, Button, Input } from "reactstrap";
import defaultprofile from "../../assets/images/defaultprofile.jpg";
import { useSelector } from "react-redux";
import { queryString } from "../../utils/queryString";
import { getAdminData } from "../../reducers/adminReducers";
import { useDispatch } from "react-redux";
import { RustyRoyalCoin } from "../../utils/SvgIcons";
const Profile = () => {
  const { tab } = queryString();
  const result = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  const { loginAdmin } = result || {};
  const { profile, firstname, lastname, email, walletAmount } =
    loginAdmin || {};
  //   console.log("Admin wallet Amount", walletAmount);

  useEffect(() => {
    dispatch(getAdminData());
  }, [dispatch]);

  return (
    <Fragment>
      <Breadcrumb title="Profile" parent="Settings" />
      <Container fluid={true}>
        <Row>
          {tab !== "preferences" && (
            <Col xl="4">
              <Card>
                <CardBody>
                  <div className="profile-details text-center">
                    <div className="profile_image">
                      <img
                        src={profile || defaultprofile}
                        alt="profile"
                        className="img-fluid img-90 rounded-circle blur-up lazyloaded"
                      />
                      <div className="edit-avtr">
                        <Input
                          className="avtr-input"
                          type="file"
                          id="imageUpload"
                          accept=".png, .jpg, .jpeg"
                        />
                        <label for="imageUpload"></label>
                      </div>
                    </div>
                    <h5 className="f-w-600 f-16 mb-0">
                      {firstname || ""} {""} {lastname || ""}
                    </h5>
                    <span className="user-email">{email || ""}</span>
                    <div className="admin-wallet">
                      <h5 className="d-flex justify-content-center align-items-center m-0 ">
                        Wallet Amount :{" "}
                        <span className="d-flex mt-2 pl-1" style={{}}>
                          <RustyRoyalCoin size={14} />
                        </span>{" "}
                        <div className="pl-1 m-0">{walletAmount}</div>
                      </h5>
                    </div>
                    <div className="social">
                      <div className="form-group btn-showcase">
                        <Button color="btn social-btn btn-fb d-inline-block">
                          {" "}
                          <i className="fa fa-facebook"></i>
                        </Button>
                        <Button color="btn social-btn btn-twitter d-inline-block">
                          <i className="fa fa-google"></i>
                        </Button>
                        <Button color="btn social-btn btn-google d-inline-block mr-0">
                          <i className="fa fa-twitter"></i>
                        </Button>
                      </div>
                    </div>
                  </div>
                  <hr />
                </CardBody>
              </Card>
            </Col>
          )}
          <Col xl={tab === "preferences" ? "12" : "8"}>
            <Card className="profile-card">
              <CardBody>
                <TabsetProfile />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Profile;
